<!--
 * @Descripttion: 文本框
 * @Author: zenghua.wang
 * @Date: 2021-12-01 10:18:42
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-23 16:13:31
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    :ref="id"
    @click="setLink(option.url, {})"
  >
    <div
      :class="setClass('panel')"
      :style="styleLink"
    >
      {{option.value}}
    </div>
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import { setPx, isEmpty, getTextByAnalysis } from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'

export default {
  name: 'drag-text',
  mixins: [bem],
  components: {},
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 200
    },
    height: {
      type: [Number, String],
      default: 36
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      animationHandler: null,
      x: 0,
      maxWidth: this.width
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        (() => {
          Object.assign(
            (() => {
              if (this.option.multiline) {
                return {
                  minHeight: setPx(this.height)
                }
              }
              return {
                height: setPx(this.height),
                whiteSpace: 'nowrap'
              }
            })(),
            {
              width: setPx(this.maxWidth - this.option.margin * 2),
              marginLeft: setPx(this.option.margin),
              marginRight: setPx(this.option.margin)
            }
          )
        })()
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    textWidth() {
      let len = (this.option.value || '').length
      return len * this.option.fontSize + len * this.option.split * 2
    },
    styleLink() {
      return {
        width:
          !this.option.multiline && this.option.animation
            ? setPx(this.textWidth)
            : 'auto',
        lineHeight: setPx(this.option.lineHeight),
        transform: `translateX(${setPx(this.x)})`,
        textAlign: this.option.textAlign,
        // letterSpacing: setPx(this.option.split),
        textIndent: setPx(this.option.split),
        fontSize: setPx(this.option.fontSize),
        fontWeight: this.option.fontWeight,
        color: this.option.color
        // backgroundColor: this.option.backgroundColor
      }
    }
  },
  watch: {
    'option.multiline'(val) {
      !val ? this.startAnimation() : this.stopAnimation()
    },
    'option.animation'(val) {
      val ? this.startAnimation() : this.stopAnimation()
    }
  },
  methods: {
    setLink(link, row) {
      let url = getTextByAnalysis(link, row)
      if (isEmpty(url)) return
      if (url.includes('http')) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    },
    startAnimation() {
      let { animation, animationTime } = this.option
      if (!this.option.multiline && animation) {
        this.animationHandler = setInterval(() => {
          if (this.x < -this.textWidth) {
            this.x = this.maxWidth
          }
          this.x = this.x - 5
        }, animationTime)
      } else {
        this.x = 0
      }
    },
    stopAnimation() {
      this.animationHandler && clearInterval(this.animationHandler)
      this.animationHandler = null
      this.x = 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.maxWidth =
        this.device === 'mobile' ? document.body.clientWidth : this.width
      this.startAnimation()
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/variables.scss';
.drag-text {
  overflow: hidden;
  box-sizing: border-box;

  &-panel {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>
